import { useMemo } from 'react'

import singularPlural from '@/utils/singularPlural'

type StartTimeBottomDisplayProps = {
  daysPlus?: number
}

/**
 * StartTimeBottomDisplay Component
 *
 * Displays additional start time information below the main time display,
 * such as day offset indicators (+1 day, etc.)
 */
export function StartTimeBottomDisplay({
  daysPlus,
}: StartTimeBottomDisplayProps) {
  const displayText = useMemo(() => {
    if (!daysPlus || daysPlus <= 0) return ''
    return `+${singularPlural(daysPlus, 'day', 'days')}`
  }, [daysPlus])

  if (!displayText) return null

  return <div className="text-xs text-white/60">{displayText}</div>
}
